import { render, staticRenderFns } from "./CytologyAccessionSpecimens.vue?vue&type=template&id=259a7f0a&scoped=true&"
import script from "./CytologyAccessionSpecimens.vue?vue&type=script&lang=js&"
export * from "./CytologyAccessionSpecimens.vue?vue&type=script&lang=js&"
import style0 from "./CytologyAccessionSpecimens.vue?vue&type=style&index=0&id=259a7f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a7f0a",
  null
  
)

export default component.exports